// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab_header[data-v-08bd6c41]{background:#eee;padding:5px 5px 5px 15px}.tab_header .tab-icon[data-v-08bd6c41]{float:left;margin-right:5px}.tab_header .tab-title[data-v-08bd6c41]{font-size:18px;color:rgba(0,0,0,.54);font-weight:500}.action-button[data-v-08bd6c41]{margin-left:30px}", ""]);
// Exports
module.exports = exports;
